// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"3a091a73","151":"ba1ce107","977":"ac7b94aa"}[chunkId] + ".chunk.js";
};